import {Component, inject, OnInit} from '@angular/core';
import {ContainerComponent} from "@coreui/angular";
import {PermissionsService} from "../../services/permissions.service";
import {
  EditFrequentlyAskedQuestionsComponent
} from "./edit-frequently-asked-questions/edit-frequently-asked-questions.component";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {
  ViewFrequentlyAskedQuestionsComponent
} from "./view-frequently-asked-questions/view-frequently-asked-questions.component";
import {FaqScreenState} from "../../enum/FaqScreenState";
import {MatButton} from "@angular/material/button";
import {ManageGameFaqsComponent} from "./manage-game-faqs/manage-game-faqs.component";

@Component({
  selector: 'app-frequently-asked-questions',
  standalone: true,
  imports: [
    ContainerComponent,
    EditFrequentlyAskedQuestionsComponent,
    ViewFrequentlyAskedQuestionsComponent,
    ManageGameFaqsComponent,
    MatButton
  ],
  templateUrl: './frequently-asked-questions.component.html'
})
export class FrequentlyAskedQuestionsComponent implements OnInit {
  private permissionsService = inject(PermissionsService);

  public canEditWebappFaqs: boolean = false;
  public canEditAdminAppFaqs: boolean = false;
  public canEditAnyFaqs: boolean = false;
  public screenState: FaqScreenState = FaqScreenState.ViewAdminAppFaqs;
  public screenStateEnum = FaqScreenState;

  ngOnInit() {
    this.permissionsService.hasCausableAdminPermissions().subscribe(hasAccess => {
      this.canEditWebappFaqs = this.permissionsService.userHasPermission(PermissionTypes.ModifyWebappFrequentlyAskedQuestions);
      this.canEditAdminAppFaqs = this.permissionsService.userHasPermission(PermissionTypes.ModifyAdminAppFrequentlyAskedQuestions);
      this.canEditAnyFaqs = this.canEditWebappFaqs || this.canEditAdminAppFaqs;

      // Always start with view mode
      this.screenState = FaqScreenState.ViewAdminAppFaqs;
    });
  }
}
